import { Box } from '@mui/material';
// import { Container } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/main.css';
// import NotificationComponent from '../custom-hooks/useNotification';



const MainLayout = (props) => {

    return(
        <Box className={`main_layout`} >
        
        {/* <NotificationComponent message={"Welcome User Let's Create some Magic"} /> */}

            {props.children}
            <ToastContainer   
                stacked         
                position="top-right"
                autoClose={3000}
                hideProgressBar={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                newestOnTop={true}
            />
        </Box>
    )
}

export default MainLayout;
